import { render, staticRenderFns } from "./CIC.vue?vue&type=template&id=0b420650&scoped=true"
import script from "./CIC.vue?vue&type=script&lang=js"
export * from "./CIC.vue?vue&type=script&lang=js"
import style0 from "./CIC.vue?vue&type=style&index=0&id=0b420650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b420650",
  null
  
)

export default component.exports